module.exports = "/assets/parrot.jpeg";